import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=6d4275f6&scoped=true"
import script from "./projectView.vue?vue&type=script&lang=js"
export * from "./projectView.vue?vue&type=script&lang=js"
import style0 from "./projectView.vue?vue&type=style&index=0&id=6d4275f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4275f6",
  null
  
)

export default component.exports